export default "__VITE_ASSET__83783a7d__"